import { render, staticRenderFns } from "./NgNotice.vue?vue&type=template&id=c087d21e&scoped=true&"
import script from "./NgNotice.vue?vue&type=script&lang=js&"
export * from "./NgNotice.vue?vue&type=script&lang=js&"
import style0 from "./NgNotice.vue?vue&type=style&index=0&id=c087d21e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c087d21e",
  null
  
)

export default component.exports